import staffRequestApi from 'api/staffRequest';
import { noRecord } from 'constants/constants';
import { handleToastError } from 'helpers';
import { useRouter } from 'next/router';
import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import {
  getOnBoardDateFilter,
} from 'store/global';
import { getSelectedCentre } from 'store/master';

const learningpath = () => {
  const [intakelist, setIntakelist] = useState([]);
  const router = useRouter();
  const selectedCentre = useSelector(getSelectedCentre);
  const onBoardDate = useSelector(getOnBoardDateFilter);

  const fetchDashboardCount = async (begin, end) => {
    try {
      let params = {
        limit: 4,
        ...(begin && { begin: new Date(begin)?.toISOString() }),
        ...(end && { end: new Date(end)?.toISOString() }),
        ...(selectedCentre && { courseCentre: selectedCentre?._id }),
      };
      const response = await staffRequestApi.getTopLearningpath(params);
      setIntakelist(response);
    } catch (error) {
      handleToastError(error);
    }
  };
  useEffect(() => {
    if (onBoardDate?.length === 2) {
      fetchDashboardCount(
        new Date(onBoardDate[0]),
        new Date(onBoardDate[1]).setHours(23, 59, 59),
      );
    }
  }, [router?.query, selectedCentre, onBoardDate]);

  return (
    <>
      <div className="learningpath-onboading-card">
        <section>
          <h6 className="onboard-dashboard-title mb-1 ">
            Most Assigned Learning Path
          </h6>
        </section>
        {intakelist?.data?.length ? (
          <section>
            {intakelist?.data?.map((name, i) => (
              <>
                <p
                  className={`${
                    i % 2 === 0 ? 'instructor-container' : ''
                  } view-page-name mb-0 py-50 px-1 text-truncate`}
                >
                  {name?.title}
                </p>
              </>
            ))}
          </section>
        ) : (
          <p className="view-page-name mb-0 py-50 px-1">{noRecord}</p>
        )}
      </div>
    </>
  );
};

export default learningpath;
